import React from 'react';
import { Section } from 'components';
import * as styles from './styles.module.scss';

const ThreeColumnTable = ({ data }) => {
  return (
    <Section className={styles.threeColTable} sliceName="ThreeColumnTable" noContainer>
      <div className={styles.threeColTableDiv}>
        {data.items.map((item) => {
          return (
            <div key={item.idx} className={styles.threeColTableContainer}>
              <div className={styles.colOne}>{item.columnone.text}</div>
              <div className={styles.colTwo}>{item.columntwo.text}</div>
              <div className={styles.colThree}>{item.columnthree.text}</div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default ThreeColumnTable;
